import { ChangeDetectorRef, Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { WidgetsQuestionModel } from 'src/app/models/widgets/widgets-question.model';
import { Logger } from 'src/app/core/logger';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';
import { ConditionalPrimitive } from 'src/app/models/formly/conditional-primitive.model';
import { CommandUpdateNodeService } from 'src/app/services/command/command-update-node.service';
import { WidgetsMetadataService } from 'src/app/services/widgets/widgets-metadata.service';
import { ToastrService } from 'ngx-toastr';
import { Config } from 'src/app/config';
import { QuestionPreviewService } from 'src/app/services/question-preview.service';
import { MetadataAreaAbstract } from 'src/app/abstract/widgets/metadata-area.abstract';
import { ActionsEnum } from 'src/app/enums/permissions/actions.enum';
import { PermissionsService } from 'src/app/services/auth/permissions.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-metadata-question',
  templateUrl: './metadata-question.component.html',
  styleUrls: ['./metadata-question.component.scss']
})
export class MetadataQuestionComponent extends MetadataAreaAbstract implements OnInit {
  @Input() data: WidgetsQuestionModel = new WidgetsQuestionModel();
  @Input() isMetadataView: boolean = false;
  @Output() onPointQuestionToggled: EventEmitter<boolean> = new EventEmitter<boolean>();
  conditionalFields: ConditionalPrimitive[] = [];
  keysList: string[] = [];
  dataTypes: string[] = [];
  tags: string[] = [];
  url:string = '';
  isQuestionSelected: boolean = true;

  // Conditionals
  isQuestionConditionalActive: boolean = Config.GLOBALS.isQuestionConditionalActive;
  hideActive: boolean = false;
  hidefield: string = '';

  // Metadata can be edited or only viewed
  isEditableQuestion: boolean = true;

  // Current user is enabled to edit questions
  isUserQuestionEditor: boolean = false;

  // Hide metadata template for form builder page
  isTemplateVisible: boolean = false;

  // Metadata can be shown from widget area or from metadata area
  // If we show metadata from Widget area, some tasks need to be completed...
  isShownFromWidgetArea = true;      // Default: metadata shown on widget area

  constructor(
    private widgetsService: WidgetsService,
    private widgetsMetadataService: WidgetsMetadataService,
    private commandReplace: CommandUpdateNodeService,
    private logger: Logger,
    public cd: ChangeDetectorRef,             // Don't remove: needed for MetadataContainer
    private toastr: ToastrService,
    private permissionsService: PermissionsService,
    private questionPreviewService: QuestionPreviewService,
    private router: Router
    ) {
    super();
  }

  ngOnInit(): void {
    this.url = this.router.url;
    const isQuestionBuilderPage = this.url.includes('question-editor');
    if(isQuestionBuilderPage){
      this.isTemplateVisible = true;
    }
    this.isUserQuestionEditor = this.permissionsService.hasUserPermission(ActionsEnum.editQuestion);
    if (this.isUserQuestionEditor && this.data.isEdit) {
      this.isEditableQuestion = true;
    } else {
      this.isEditableQuestion = false;
    }

    this.conditionalFields = this.widgetsService.getConditionalFieldsInNode(this.data.parentId);
    
    // Retrieve hidefield
    if (this.data.hideField) {
      this.hideActive = true;
      this.hidefield = this.data.hideField;
    }
    this.dataTypes.push(this.data.TypeName ? this.data.TypeName: '');
    if (this.data.tags) {
      this.tags = this.data.tags;
    }
    this.isEdit = Config.GLOBALS.isQuestionSaveButtonEnabled;
    this.widgetsService.getDataPointsList(this.keysList, this.data).then(() => {
      // this.logger.debug("KeyListIds=["+this.keysList.toString()+"]");
    });
  }

  onHide($event: any) {
    if (this.hideActive && this.hidefield) {
      // This is for radio Yes/No (1/0). Works for checkbox too (true/false)
      // TODO: Check if we need conditionals for empty input field as well
      this.data.template = "{ \"expressions\": \"{ \"hide\" : field.parent.model."+this.hidefield+" != 1\" }}";
      this.data.hideField = this.hidefield;
    } else {
      this.data.template = "";
      this.data.hideField = undefined;
    }
  }

  changeKey(prevKey, newKey) {
    const value = this.data.labelOverrides[prevKey];
    delete this.data.labelOverrides[prevKey];
    this.data.labelOverrides[newKey] = value;
    // this.logger.log(this.data.labelOverrides);
  }

  changeValue(key, value) {
    this.data.labelOverrides.set(key, value);
    // this.logger.log("changeValue: ["+key+ "," + value + "] [" + this.data.labelOverrides[key] + "]");
  }

  onToggleOnPointQuestion(event: boolean) {
    this.data.isOnPoint = event;
    this.onPointQuestionToggled.emit(event);
    this.widgetsService.setLayoutTouched();
  }

  onCancel() {
    this.logger.log("Cancel update question");
  }

  trimFirstChar(str: string) {
    return str.substring(1);
  }

  onSave() {
    this.commandReplace.executeAsync(this.widgetsService.getLayoutRoot(), this.data)
      .then((updatedNode) => {
        this.data = updatedNode as WidgetsQuestionModel;
        this.logger.log("Question updated: "+this.data.name);
        this.toastr.success("Question updated: "+this.data.name);

        if (this.isShownFromWidgetArea) {
          // If modified from widget area: refresh metadata area with new data
          this.widgetsMetadataService.showMetadata(this.data);
        }
      })
      .catch((error) => {
        this.logger.warn("Replace Question Error "+error);
        this.toastr.warning("Error updating question");
      });
  }

  onPreviewQuestion() {
    // data used for preview Question data transfer
    this.questionPreviewService.data = this.data;
    // booleanValue used to toggle preview dialog (show = true , hide = false)
    this.questionPreviewService.sendValue(true);
  }

  onEditQuestion() {
    // We edit the question in another page
    if (this.data.dbId) {
      this.router.navigate([Config.CONSTANTS.routeQuestionEditor], {
        queryParams: { id: this.data.dbId },
      }).then(() => {
        window.location.reload();
      });
    }
  }

  getModifiedTemplate(modifiedTemplate){
    if (modifiedTemplate && modifiedTemplate !="") {
      this.data.template = modifiedTemplate.template;
    }
  }
}
